import React from 'react';
import Image from 'next/image';
import CTA from 'react-scale/components/ui/cta';

const rapidHero = () => (
  <section className="relative my-12 text-white md:pt-24 md:mt-24">
    <div className="container">
      <div className="flex flex-wrap items-center gap-12 px-10 py-10 md:px-20 xl:gap-0 md:flex-nowrap bg-codGray rounded-3xl">
        <div className="w-full md:w-7/12">
          <h4 className="mb-6 text-3xl font-normal md:font-light md:text-4xl lg:text-5xl font-aeonik lg:leading-tight">
            Interested in{' '}
            <span className="block">
              <strong className="font-normal text-transform-gradient">Rapid</strong> labels
            </span>{' '}
            for your model?
          </h4>
          <p className="mb-12">Sign up for the fastest way to production-quality labeled data.</p>
          <div className="xl:w-5/6">
            <CTA
              cta={{
                buttons: [
                  {
                    text: 'Label My Data',
                    href: 'https://dashboard.scale.com/signup?product=rapid'
                  }
                ]
              }}
            />
          </div>
        </div>
        <div className="w-full md:w-5/12 md:-mb-6">
          <Image width="549" height="496" src="/static/images/pages/homepage/rapid-banner.png" />
        </div>
      </div>
    </div>
  </section>
);

export default rapidHero;
